import React, { FC } from 'react'
import './index.scss'

interface IProps {
  text?: string;
  rate?: number;
  extraText?: string;
}

const SaleProgress: FC<IProps> = (props: IProps) => {
  const { text, rate, extraText } = props
  return (
    <div className='progress-bar'>
      <div className='bar-con' style={{ width: `${rate === undefined ? 100 : rate}%` }}></div>
      <div className='bar-show'></div>
      <div className='bar-text'>
        <div className='text'>{text || `${rate === undefined ? 100 : rate}%`}{extraText ? <span className='bar-text-extra'>{extraText}</span> : null}</div>
      </div>
    </div>
  )
}

export default SaleProgress
